import { AnchorHTMLAttributes } from 'react'
import tw, { TwStyle } from 'twin.macro'

type LinkProps = {
  twStyle?: TwStyle
} & AnchorHTMLAttributes<HTMLAnchorElement>

const Link = ({ children, twStyle, ...linkProps }: LinkProps) => {
  return (
    <a css={[tw`underline text-primary-middle`, twStyle]} {...linkProps}>
      {children}
    </a>
  )
}

export default Link
